function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M53.9,0c0.3,0.1,0.6,0.2,0.9,0.2c3,0.7,4.5,2.8,5.2,5.7c0.2,1,0.3,2.1,0.3,3.1c0,4.2,0,8.4,0,12.6 c0,0.2,0,0.4,0,0.6h-5.8v-0.9c0-3.6,0-7.1,0-10.7c0-0.9-0.1-1.8-0.4-2.7c-0.9-3.4-4.6-3.1-6.2-1.6c-1.2,1.3-1.6,2.8-1.7,4.5 c0,3.5,0,6.9,0,10.4c0,0.3,0,0.6,0,0.9h-5.9v-0.9c0-3.5,0-7,0-10.5c0-0.9-0.1-1.8-0.3-2.7c-0.3-1.4-1.1-2.5-2.6-2.8 c-1.6-0.3-3,0.1-4.1,1.4c-0.8,1-1.3,2.1-1.3,3.4c-0.1,3.7-0.1,7.3-0.1,11c0,0.3,0,0.7,0,1.1h-5.8V0.4h5.7V3L32,3.1 c1.4-1.7,3.2-2.7,5.4-3.1h2.5c0.7,0.2,1.5,0.4,2.1,0.7c1.3,0.6,2.3,1.5,2.8,2.6c1.3-0.9,2.6-1.8,3.9-2.5c0.8-0.4,1.7-0.5,2.6-0.7 H53.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M16.9,11.4c0-0.2,0-0.4,0-0.6c-0.2-3.5-3.1-6-6.3-5.5c-2.5,0.4-4.2,2-4.7,4.5c-0.6,2.6,0.3,5.3,2.3,6.6 c1.9,1.2,3.9,1.3,5.9,0.3C16.1,15.6,16.8,13.6,16.9,11.4 M13.9,0c0.5,0.1,1,0.2,1.5,0.4c4.1,1.3,6.3,4.2,7.2,8.3 c0.6,3,0.3,5.9-1.1,8.7c-2.3,4.3-7.5,6.4-12,4.8c-1.2-0.4-2.3-1.3-3.5-2v5.3v5.7H0V0.3h5.9v2.3C6.8,2.1,7.5,1.4,8.4,1 c0.9-0.4,1.8-0.7,2.7-1H13.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M86.3,26.7c-1.2,3-2.5,5.9-3.7,8.9c-1,2.3-1.9,4.6-2.9,6.9c-0.4,1-0.5,1.1-1.8,0.8c0.6-1.5,1.2-3,1.8-4.5 c0.1-0.4,0.1-0.9,0-1.3c-1.5-3.4-3-6.7-4.5-10.1c-0.1-0.3-0.2-0.6-0.4-0.9c1.3-0.2,1.3-0.2,1.8,0.9c1.3,3,2.6,6,4,9.1 c0.2-0.3,0.3-0.6,0.4-0.8c1.1-2.7,2.2-5.3,3.3-8c0.5-1.3,0.5-1.3,2-1.3V26.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M34.1,32.3c0-2.7-1.8-4.6-4.4-4.7c-2.7,0-4.6,1.9-4.6,4.7c0,2.7,1.9,4.7,4.5,4.7 C32.2,37.1,34.1,35.1,34.1,32.3 M34.1,36.2c-2.7,3.1-6.4,2.7-8.7,0.4c-2.1-2.2-2.2-6.2,0-8.5c2.3-2.4,6.5-2.7,8.7,0.4v-1.9h1.3 v2.1c0,3.1,0,6.2,0,9.2c0,0.9-0.2,1.9-0.5,2.7c-0.8,1.9-2.4,2.7-4.3,2.9c-1.7,0.2-3.3-0.1-4.8-0.8c-1.1-0.5-1.1-0.5-0.6-1.7 c1.6,1,3.3,1.4,5.1,1.3c2.3-0.2,3.7-1.7,3.7-4C34.1,37.7,34.1,37,34.1,36.2"
}), React.createElement("path", {
  className: "st0",
  d: "M20.1,32.6c0-2.8-1.9-5-4.5-5c-2.7,0-4.6,2.1-4.7,4.9c0,2.7,1.9,4.8,4.6,4.8C18.2,37.4,20.1,35.4,20.1,32.6  M21.4,38.5h-1.2v-2.1c-2.9,2.8-6.4,3-8.8,0.6c-2.3-2.3-2.2-6.6,0.1-8.9c2.4-2.4,6.5-2.5,8.6,0.6v-2.1h1.3V38.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M39.2,31.6h8.1c0-2.1-1.6-3.8-3.6-3.9C41.3,27.6,39.3,29.3,39.2,31.6 M39,32.9c0.2,2,0.9,3.5,2.8,4.2 c2.1,0.8,3.9,0.2,5.5-1.4c0.3,0.2,0.6,0.5,0.9,0.8c-0.9,1.2-2.1,1.9-3.5,2.2c-3.1,0.6-6.1-1.2-6.8-4.3c-0.8-3.5,0.8-6.8,3.9-7.6 c4.4-1.2,7.4,2.5,6.8,6.2h-4.7H39z"
}), React.createElement("path", {
  className: "st0",
  d: "M52.3,38.5h-1.2V26.6h1.3v2.2c1.1-1.4,2.3-2.1,3.8-2.3c2.6-0.4,4.5,0.9,4.7,3.5c0.2,2.8,0,5.7,0,8.5h-1.2 c0-0.3,0-0.6,0-0.9c0-2.2,0-4.4,0-6.5c-0.1-1.9-0.7-2.9-2-3.3c-1.5-0.4-3.3,0.3-4.3,1.6c-0.5,0.7-0.9,1.5-1,2.4 c-0.2,1.9-0.1,3.8-0.1,5.7C52.3,37.8,52.3,38.1,52.3,38.5"
}), React.createElement("path", {
  className: "st0",
  d: "M73.8,28.4c-0.3,0.3-0.6,0.5-0.9,0.8c-2.8-2-5.5-2.1-7.2-0.1c-1.6,1.9-1.5,5.2,0.2,7c1.8,1.8,4.7,1.7,7-0.3 c0.3,0.3,0.6,0.5,0.8,0.8c-2.1,2.4-6.3,2.7-8.7,0.5C62.7,35,62.6,30.4,65,28C67.3,25.7,71.5,25.9,73.8,28.4"
})), React.createElement("polygon", {
  className: "st0",
  points: "62.6,22.2 69.7,22.3 76.1,12.7 69.1,12.7  "
}), React.createElement("polygon", {
  className: "st0",
  points: "62.6,0.5 69.1,10 76.1,10 69.7,0.5  "
}), React.createElement("polygon", {
  className: "st0",
  points: "79.3,0.4 76.4,5.2 79.5,10 86.3,0.4  "
}), React.createElement("polygon", {
  className: "st0",
  points: "76.3,17.5 79.2,22.2 86.3,22.2 79.5,12.6  "
}));

var SvgLogoPmx = function SvgLogoPmx(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 86.3 43.6",
    style: {
      enableBackground: "new 0 0 86.3 43.6"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/logo-pmx.33bfa4ec.svg";
export { SvgLogoPmx as ReactComponent };